import { Level } from "@serophin/nottldr-shared";
import { levelStyle } from "../../../components/author/levelStyles";
import { Section, SectionHeading } from "./Section";

type LevelInfo = { name: string; blurb: string; length: string; tone: string };

const LEVELS: LevelInfo[] = [
  {
    name: "Beginner",
    blurb: "New to a topic? Gentle, jargon-free and easy to follow.",
    length: "About 4 to 5 minutes",
    tone: levelStyle(Level.Beginner).border,
  },
  {
    name: "Intermediate",
    blurb: "You know the basics and want a bit more depth.",
    length: "Somewhere in between",
    tone: levelStyle(Level.Intermediate).border,
  },
  { name: "Advanced", blurb: "Already curious? More detail and fewer hand-holds.", length: "Up to 9 minutes", tone: levelStyle(Level.Advanced).border },
];

const LevelCard = ({ name, blurb, length, tone }: LevelInfo) => (
  <div class={`rounded-2xl bg-white dark:bg-neutral-800 border-t-4 ${tone} shadow-md shadow-gray-500/20 p-6`}>
    <h3 class="text-xl font-bold text-gray-900 dark:text-gray-50">{name}</h3>
    <p class="mt-2 text-gray-600 dark:text-gray-300">{blurb}</p>
    <p class="mt-4 text-sm font-medium text-gray-500 dark:text-gray-400">{length}</p>
  </div>
);

export const Levels = () => (
  <Section class="bg-white dark:bg-neutral-950/40">
    <SectionHeading title="Start wherever you are" intro="Every subject is written for three levels, so you are never lost and never bored." />
    <div class="grid gap-4 md:grid-cols-3">
      {LEVELS.map((level) => (
        <LevelCard key={level.name} {...level} />
      ))}
    </div>
  </Section>
);
